
import { Link } from 'react-router-dom';

export default function Home() {
  return (
    <div className="min-h-screen flex items-center justify-center relative overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/aa4136f1d5bda1b7b4e94a4d8795e51a.jpg)'
        }}
      />
      
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      
      {/* Content */}
      <div className="relative z-10 text-center px-6 w-full">
        {/* Brand Name */}
        <h1 className="text-6xl md:text-7xl font-bold text-white mb-4 tracking-wider" style={{ fontFamily: "'Pacifico', cursive" }}>
          Twin Bermers
        </h1>
        
        {/* Tagline */}
        <p className="text-2xl md:text-3xl text-teal-300 mb-12 font-semibold drop-shadow-lg">
          Buat Website Berbasis AI Hanya 15.000
        </p>
        
        {/* Main Heading */}
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-8 drop-shadow-lg">
          Anda Ingin Membuat Website?
        </h2>
        
        <p className="text-2xl md:text-3xl text-white mb-12 drop-shadow-lg">
          Hubungi Kami
        </p>
        
        <Link 
          to="/contact"
          className="inline-block bg-gradient-to-r from-teal-500 to-cyan-500 hover:from-teal-600 hover:to-cyan-600 text-white font-semibold px-12 py-4 rounded-full text-lg transition-all duration-300 transform hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer"
        >
          Hubungi Sekarang
        </Link>
      </div>
    </div>
  );
}
